import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Input, Button, Spin, Select } from 'antd';
import { AuthWrapper } from '../../style';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import { requestOTP, reduceStep } from '../../../../../../redux/authentication/actionCreator';
import ReactGA from 'react-ga';
import api from '../../../../../../redux/authentication/api';
// import e from 'cors';
import './InputStyles.scss';

function BasicDetails() {
  const { signinTokenValidationFailed } = useSelector(state => state.auth);

  const [form] = Form.useForm();
  let query = new URLSearchParams(useLocation().search);
  let code = query.get('referralKey');
  useEffect(() => {
    ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Click On Register' });
  }, []);
  const [state, setState] = useState({
    values: null,
    checked: null,
  });

  const [myStates, setMyStates] = useState(null);
  const [mlCities, setMlCities] = useState(null);
  const [empStatus, setEmpStatus] = useState(null);
  const [occupationType, setOccupationType] = useState(null);
  const [isEnableOcupationType, setIsEnableOcupationType] = useState(true);

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);
  const onBackButtonEvent = e => {
    e.preventDefault();
    changeStep();
  };

  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.loading);
  const inline = useSelector(state => state.auth.inline);

  const handleSubmit = values => {
    setState({ ...state, values });
    ReactGA.event({ category: 'Kongsi Klub Signup', action: 'Enter Profile Details' });
    const params = {
      phoneNumber: `60${values.phone}`,
      name: values.name,
      email: values.email,
      nric: values.nric,
      age: values.age,
      referralCode: signinTokenValidationFailed ? '' : `${code ? code : values.referral ? values.referral.trim() : ''}`,
      addressLine1: values.addressLine1,
      addressLine2: values.addressLine2,
      postcode: values.postcode,
      stateId: values.state,
      cityId: values.mCity,
      employmentStatus: values.employmentStatus,
      occupationType: `${isEnableOcupationType ? '' : values.occupationType}`,
    };
    dispatch(requestOTP(params, true));
  };

  const handleInlineError = inline => {
    if (inline) {
      const error = 'Kod Promo anda tidak sah';
      return <span style={{ color: 'red' }}>{inline.message ? error : ''}</span>;
    }
  };

  const onChange = checked => {
    setState({ ...state, checked });
  };

  useEffect(() => {
    const getMlStates = async () => {
      if (!myStates) {
        let data = await api.get('/signup/states');
        setMyStates(data.data);
      }
    };
    getMlStates();
  }, [myStates]);

  const handleMStateChange = e => {
    form.setFieldsValue({ mCity: null });
    let cityArr = myStates.filter(item => item.id === e);
    setMlCities(cityArr[0].cities);
  };

  useEffect(() => {
    const getEmpStatus = async () => {
      if (!empStatus) {
        let data = await api.get('/signup/config?type=3');
        setEmpStatus(data.data);
      }
    };
    getEmpStatus();
  }, [empStatus]);

  useEffect(() => {
    const getOccupationType = async () => {
      if (!occupationType) {
        let data = await api.get('/signup/config?type=2');
        setOccupationType(data.data);
      }
    };
    getOccupationType();
  }, [occupationType]);

  const handleSelectOption = e => {
    if (e === 59 || e === 193 || e === 64) {
      setIsEnableOcupationType(true);
    } else {
      setIsEnableOcupationType(false);
    }
  };

  const changeStep = () => {
    dispatch(reduceStep());
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="register" onFinish={handleSubmit} layout="vertical" form={form}>
          <Heading as="h5">
            Daftar untuk &nbsp;
            <img style={{ width: '108px', height: '54px', borderRadius: '7px' }} src="images/nav-logo.png" />
          </Heading>
          <Form.Item
            label="Nama Seperti di MyKad"
            name="name"
            rules={[{ required: true, message: 'Nama Seperti di MyKad diperlukan' }]}
          >
            <Input placeholder="Nama Seperti di MyKad" />
          </Form.Item>
          <Form.Item
            label="Nombor MyKad"
            name="nric"
            rules={[
              { required: true, message: 'Nombor IC diperlukan' },
              { pattern: /^\d{6}-\d{2}-\d{4}$/, message: 'Format Nombor IC 000000-00-0000' },
            ]}
          >
            <Input placeholder="886426-10-4132" />
          </Form.Item>
          <Form.Item
            name="age"
            rules={[
              { message: 'Umur mestilah melebihi 18 tahun', required: true },
              { pattern: /^(1[8-9]|[2-9][0-9])$/, message: 'Sumur mestilah melebihi 18 tahun' },
            ]}
            label="Umur"
          >
            <Input type="text" placeholder="Umur minimum ialah 18" />
          </Form.Item>
          <Form.Item
            name="email"
            label="Alamat Emel"
            rules={[
              { required: true, message: 'Emel diperlukan' },
              { type: 'email', message: 'Sila isikan emel yang sah' },
            ]}
          >
            <Input type="email" placeholder="username@email.com" />
          </Form.Item>
          <Form.Item
            name="phone"
            rules={[
              { message: 'Sila masukkan nombor telefon anda!', required: true },
              { pattern: /^[0-9]{9,11}$/, message: 'Sila isikan nombor telefon yang sah' },
            ]}
            label="Nombor Telefon Bimbit"
          >
            <Input type="number" addonBefore={'+60'} placeholder="1023456489" />
          </Form.Item>
          <Form.Item
            label="Alamat Baris 1"
            name="addressLine1"
            rules={[
              { required: true, message: 'Sila masukkan alamat yang sah' },
              { max: 50, message: 'Sila masukkan alamat yang sah' },
            ]}
          >
            <Input type="text" placeholder="Alamat Baris 1" />
          </Form.Item>

          <Form.Item
            label="Alamat Baris 2"
            name="addressLine2"
            rules={[{ max: 50, message: 'Sila masukkan alamat yang sah' }]}
          >
            <Input type="text" placeholder="Alamat Baris 2" />
          </Form.Item>
          <Form.Item
            label="Poskod"
            name="postcode"
            rules={[
              { required: true, message: 'Sila masukkan Poskod yang sah' },
              { len: 5, message: 'Sila masukkan Poskod yang sah' },
              { pattern: /^[0-9]+$/, message: 'Sila masukkan Poskod yang sah' },
            ]}
          >
            <Input type="text" placeholder="Poskod" />
          </Form.Item>
          <Form.Item label="Negeri" name="state" rules={[{ required: true, message: 'Sila pilih negeri' }]}>
            <Select onSelect={handleMStateChange} placeholder="Sila Pilih">
              {myStates &&
                myStates.map((item, i) => (
                  <Select.Option style={{ backgroundColor: 'white' }} key={i} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item label="Bandar" name="mCity" rules={[{ required: true, message: 'Sila pilih bandar' }]}>
            <Select placeholder="Sila Pilih">
              {mlCities &&
                mlCities.map((item, i) => (
                  <Select.Option style={{ backgroundColor: 'white' }} key={i} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Status Pekerjaan"
            name="employmentStatus"
            rules={[{ required: true, message: 'Sila pilih status pekerjaan' }]}
          >
            <Select placeholder="Sila Pilih" onSelect={handleSelectOption}>
              {empStatus &&
                empStatus.map((item, i) => (
                  <Select.Option style={{ backgroundColor: 'white' }} key={i} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Jenis Pekerjaan"
            name="occupationType"
            rules={[{ required: !isEnableOcupationType, message: 'Sila pilih jenis pekerjaan' }]}
          >
            <Select disabled={isEnableOcupationType} placeholder="Sila Pilih">
              {occupationType &&
                occupationType.map((item, i) => (
                  <Select.Option style={{ backgroundColor: 'white' }} key={i} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item name="referral" label="Kod Promo">
            <div>
              {signinTokenValidationFailed ? (
                <>
                  {' '}
                  <Input disabled />
                </>
              ) : (
                <>
                  {' '}
                  <Input
                    {...(code
                      ? {
                          value: `${code}`,
                          disabled: true,
                        }
                      : {})}
                  ></Input>
                </>
              )}

              {handleInlineError(inline)}
            </div>
          </Form.Item>

          <div className="auth-form-action">
            <Checkbox onChange={onChange}>
              Saya akui bahawa saya telah baca, fahami dan setuju dengan{' '}
              <a
                href="https://aspirasi-co-assets.s3-ap-southeast-1.amazonaws.com/kongsi/General+Terms+And+Conditions+For+Kongsi+Klub.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'red' }}
              >
                Terma-terma dan Syarat
              </a>{' '}
              dan{' '}
              <a
                href="https://aspirasi-co-assets.s3-ap-southeast-1.amazonaws.com/kongsi/Privacy+Notice+-+Referral+Program.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'red' }}
              >
                Notis Privasi
              </a>
              .
            </Checkbox>
          </div>
          <Form.Item>
            <Button
              className="btn-create"
              htmlType="submit"
              type="primary"
              size="large"
              disabled={!state.checked || isLoading}
            >
              {isLoading ? <Spin /> : 'JOM KONGSI!'}
            </Button>
          </Form.Item>
          <p>
            Sudah ada akaun?{' '}
            <NavLink style={{ color: 'red' }} to="/" onClick={changeStep}>
              Log masuk
            </NavLink>
          </p>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default BasicDetails;
